import { createContext } from 'react';

export const HelpTextContext = createContext(false);
